import { render, staticRenderFns } from "./FilterTablePowerUser.vue?vue&type=template&id=12217544&"
import script from "./FilterTablePowerUser.vue?vue&type=script&lang=ts&"
export * from "./FilterTablePowerUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports